/* PR-2 #5: Extracted from main-product.liquid (was inline DOMContentLoaded handler).
   Loaded via defer to keep parser unblocked. Pure JS — no Liquid templating. */
  document.addEventListener('DOMContentLoaded', () => {
    // open popup
    const pdpBtnPopup = document.querySelector('#pdp__btn-popup');
    const pdpPopup = document.querySelector('.pdp__popup');

    function syncPopupFlavor() {
      const fieldset = document.querySelector('fieldset.product-form__input--pill');
      const value = fieldset?.querySelector('input:checked')?.value ?? '';
      const slug = value.toLowerCase().replace(/\s+/g, '-');
      pdpPopup?.querySelectorAll('.pdp__flavor-label').forEach((label) => label.classList.remove('is-active'));
      pdpPopup?.querySelector(`.pdp__flavor-color--${slug}`)?.closest('.pdp__flavor-label')?.classList.add('is-active');
    }

    pdpBtnPopup?.addEventListener('click', () => {
      syncPopupFlavor();
      pdpPopup?.classList.remove('is-hide-popup');
    });

    document.querySelector('.pdp__popup')?.addEventListener('click', (e) => {
      const label = e.target.closest('.pdp__flavor-label');
      if (!label) return;

      const colorSpan = label.querySelector('[class*="pdp__flavor-color--"]');
      const slug = [...colorSpan.classList].find((c) => c.startsWith('pdp__flavor-color--') && c !== 'pdp__flavor-color')?.replace('pdp__flavor-color--', '');

      if (!slug) return;

      const inputs = document.querySelectorAll('fieldset.product-form__input--pill input[type="radio"]');
      const target = [...inputs].find((input) => input.value.toLowerCase().replace(/\s+/g, '-') === slug);

      if (target) {
        target.click();
        syncPopupFlavor();
      }
    });

    const widget = document.querySelector('recharge-subscription-widget');
    if (widget) {
      const styleContent = `
    .rc-purchase-option {
      border-radius: 8px !important;
      border: 1px solid #EAEAEA !important;
    }
    .rc-purchase-option[rc-selected] {
      border: 1px solid #40543E !important;
    }

    .rc-purchase-option:nth-child(1):before {
      content: "Subscribe & Save 20%";
      display: block;
      width: 100%;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 138%;
      font-weight: 500;
      background: #40543E;
      text-align: center;
      padding: 7.5px 0;
      border-radius: 7px 7px 0 0;
    }
    .rc-purchase-option[rc-not-selected]:nth-child(1):before {
      opacity: 0.5;
    }
    #rc-subscription-badge {
      display: none;
    }
    .compact .rc-purchase-option__prices {
      flex-direction: row !important;
      gap: 8px;
      font-size: 20px;
      line-height: 130%;
      font-weight: 500;
      color: #131211;
    }
    .rc-purchase-option__selector {
      font-size: 20px !important;
      line-height: 130%;
      font-weight: 400 !important;
      color: #2D2C29;
    }
    #rc-benefits * {
      font-size: 14px !important;
      line-height: 150%;
      font-weight: 400 !important;
      color: #575654 !important;
    }
    .rc-plans-button[data-checked] {
      border: 1px solid #EAEAEA !important;
      background: none !important;
    }
    .rc-price {
      font-weight: 500 !important;
    }
    rc-radio-icon {
      color: #EAEAEA !important;
    }
    .rc-purchase-option[rc-selected] {
      color: #575654 !important;
    }
  `;

      const tryInject = () => {
        if (!widget.shadowRoot) return;
        if (widget.shadowRoot.querySelector('#rc-custom-styles')) return;

        const style = document.createElement('style');
        style.id = 'rc-custom-styles';
        style.textContent = styleContent;
        widget.shadowRoot.appendChild(style);
      };

      const bodyObserver = new MutationObserver(tryInject);
      bodyObserver.observe(document.body, { childList: true, subtree: true });

      const watchShadowRoot = () => {
        if (!widget.shadowRoot) return;
        const shadowObserver = new MutationObserver(tryInject);
        shadowObserver.observe(widget.shadowRoot, { childList: true, subtree: true });
      };

      const interval = setInterval(() => {
        if (widget.shadowRoot?.querySelector('.rc-purchase-option')) {
          tryInject();
          watchShadowRoot();
          clearInterval(interval);
        }
      }, 300);
    }
  });
